export class BookingDivOracle {
    constructor() {
    }

    addLoading(){
        this.bookingDiv().classList.add('loader');
    }

    removeLoading(){
        this.bookingDiv().classList.remove('loader');
    }

    bookingDiv(){
        return document.querySelector('#div_rez');
    }
}